import * as Yup from 'yup';
import { States } from '../../../../../constants';
import { zipCodeRegEx } from '../../../../../utils/RegularExpressions';

export const projectTypes: { id: string; label: string; name: string }[] = [
  {
    id: 'companyCompletedAffordable',
    name: 'affordable',
    label: 'Affordable',
  },
  {
    id: 'companyCompletedWorkForce',
    name: 'workForce',
    label: 'Work Force',
  },
  {
    id: 'companyCompletedMaraketRate',
    name: 'maraketRate',
    label: 'Market Rate',
  },
  {
    id: 'companyCompletedSenior',
    name: 'senior',
    label: 'Senior',
  },
  {
    id: 'companyCompletedMixedIncome',
    name: 'mixedIncome',
    label: 'Mixed Income',
  },
  {
    id: 'companyCompletedMixedUse',
    name: 'mixedUse',
    label: 'Mixed Use',
  },
  {
    id: 'companyCompletedCommercialProject',
    name: 'commercialProject',
    label: 'Commercial Project',
  },
];
export const constructionTypes: { id: string; label: string; name: string }[] =
  [
    {
      id: 'companyCompletedNewConstruction',
      name: 'newConstruction',
      label: 'New Construction',
    },
    {
      id: 'companyCompletedHistoricRenovation',
      name: 'historicRenovation',
      label: 'Historic Renovation',
    },
    {
      id: 'companyCompletedRenovation',
      name: 'renovation',
      label: 'Renovation',
    },
    {
      id: 'companyCompletedAdaptiveReuse',
      name: 'adaptiveReuse',
      label: 'Adaptive Reuse',
    },
    {
      id: 'companyCompletedInplaceRenovation',
      name: 'inplaceRenovation',
      label: 'In-Place Renovation',
    },
  ];
export const companyRoles: { id: string; label: string; name: string }[] = [
  {
    id: 'companyCompletedLeadSponsor',
    name: 'leadSponsor',
    label: 'Lead Sponsor/Managing Member',
  },
  {
    id: 'companyCompletedCoSponsor',
    name: 'coSponsor',
    label: 'Co-Sponsor',
  },
  {
    id: 'companyCompletedLimitedPartner',
    name: 'limitedPartner',
    label: 'Limited Partner',
  },
  {
    id: 'companyCompletedSourcedOpportunity',
    name: 'sourcedOpportunity',
    label: 'Sourced Opportunity',
  },
  {
    id: 'companyCompletedFullOwner',
    name: 'fullOwner',
    label: 'Full Owner',
  },
];

const validProjectTypes: string[] = projectTypes.map((pType) => pType.label);
const validConstructionTypes: string[] = constructionTypes.map(
  (pType) => pType.label
);
const validCompanyRoles: string[] = companyRoles.map((role) => role.label);
const today = new Date();

export const validationSchema = Yup.object({
  projectName: Yup.string()
    .required('Project Name is required')
    .min(2, 'Project Name must be greater than 2 character'),
  dateCompleted: Yup.date()
    .required('Date Completed is required')
    .typeError('Date is invalid')
    .max(today, 'Completed Data cannot be in future.'),
  streetAddress: Yup.string()
    .required('Street Address is required')
    .min(4, 'Street Address must be greater than 4 character'),
  city: Yup.string()
    .required('City is required')
    .min(2, 'City must be greater than 2 character'),
  state: Yup.string()
    .required('State is required')
    .transform((v) => v.value),
  zipCode: Yup.string()
    .required('Zip / Postal code is required')
    .matches(zipCodeRegEx, 'Zip / Postal Code must be a 5 digit number')
    .max(5, 'Zip / Postal Code must be 5 digits')
    .min(5, 'Zip / Postal Code must be 5 digits'),
  grossBuildingArea: Yup.number()
    .required('Gross Building Area is required')
    .typeError('Gross Building Area must be a number')
    .positive('Gross Building Area must bNumber of Housing Units')
    .min(1, 'Gross Building Area must be greater than 1'),
  housingUnits: Yup.number()
    .typeError('Number of Housing Units must be a number')
    .min(0, 'Number of Housing Units must be positive number'),
  developmentCost: Yup.number()
    .required('Total Development Cost is required')
    .typeError('Total Development Cost must be a number')
    .positive('Total Development Cost must be greater than 0.')
    .integer('Total Development Cost must be whole number not in decimal.'),
  projectTypes: Yup.array()
    .of(Yup.string())
    .min(1, 'Project Type is required')
    .typeError('Project Type is required'),
  constructionTypes: Yup.array()
    .of(Yup.string())
    .min(1, 'Construction Type is required')
    .typeError('Construction Type is required'),
  companyRole: Yup.array().of(Yup.string()),
  partialOwner: Yup.number()
    .typeError('Partial Owner percent must be a number')
    .positive('Partial Owner percent cannot be in negative or 0')
    .notRequired()
    .nullable()
    .transform((v) => (Number.isNaN(v) ? null : v)),
});
